import { lazy } from 'react';
import i18next from 'i18next';

import { PERMISSIONS } from '../teams/constants/permissions';
import { UNIVERSAL_LINKS_KEY } from './store/universalLinkSlice';
import { PATHS } from './constants';

const UniversalLinksList = lazy(() => import('./UniversalLinksList/UniversalLinksList'));

['uk-UA', 'en-US'].forEach((lang) =>
  i18next.addResourceBundle(lang, UNIVERSAL_LINKS_KEY, require(`./i18n/${lang}`).default)
);

const AUTH = [
  PERMISSIONS.UniversalLinksAll.value,
  PERMISSIONS.ListUniversalLinks.value,
  PERMISSIONS.OnlyTestMode.value,
];

export const UniversalLinksNavigationConfig = {
  id: UNIVERSAL_LINKS_KEY,
  title: 'Universal links',
  translate: 'UNIVERSAL_LINKS',
  type: 'item',
  icon: 'navigation:universal-link',
  url: PATHS.UNIVERSAL_LINKS_LIST,
  auth: AUTH,
};

export const UniversalLinksConfig = {
  settings: { layout: { config: {} } },
  auth: AUTH,
  routes: [
    {
      path: PATHS.UNIVERSAL_LINKS_LIST,
      element: <UniversalLinksList />,
    },
  ],
};
